import { Eye } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function PDFPreview() {
  const { t } = useLanguage();
  const tk = t.tools.pdfPreview;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/preview",
    accept: ".pdf",
    multiple: false,
    resultType: "image",
    resultFileName: tk.result,
    color: "#9333ea",
    Icon: Eye,
    toolKey: "pdfPreview",
    downloadImageLabel: tk.downloadImage,
  };

  return <ToolPage config={config} />;
}
